export class IdentityInfoEditorFormNaming {
    // controls in formGroup root
    public readonly genderControlName: string = 'xGender';
    public readonly birthDateControlName: string = 'birthDate';
    public readonly identityTypeControlName: string = 'identityType';
    public readonly passportCitizenshipControlName: string = 'passportCitizenship';
    public readonly identityCardCitizenshipControlName: string = 'identityCardCitizenship';

    // groups for passport and identityCard
    public readonly passportGroupName: string = 'passport';
    public readonly identityCardGroupName: string = 'identityCard';

    // child controls of 'passport' and/or 'identityCard'
    public readonly passNumberControlName: string = 'passNumber';
    public readonly identityCardNumberControlName: string = 'cardNumber';

    public readonly validityGroupName: string = 'validity';
    public readonly passEndControlName: string = 'passEnd';
    public readonly cardEndControlName: string = 'cardEnd';

    public readonly issuanceGroupName: string = 'issuance';
    public readonly passCountryControlName: string = 'passCountry';
    public readonly cardCountryControlName: string = 'cardCountry';
}
